import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runMutationOnce, runQueryOnce, stripEmptyParams } from '@/pages/shared/rtk-query-helpers';

export const userProfileApi = createApi({
    reducerPath: 'userProfileApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getContactDetails: builder.query({
            query: (id) => ({ url: `/api/contact/${id}`, method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        saveStaffDetails: builder.mutation({
            query: (model) => ({ url: '/api/staff/save', method: 'POST', body: model }),
        }),
        getStaffDetails: builder.query({
            query: (staffId) => ({ url: `/api/staff/${staffId}`, method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        saveContactDetails: builder.mutation({
            query: (model) => ({ url: '/api/contact/save', method: 'POST', body: model }),
        }),
        getDashboards: builder.query({
            query: () => ({ url: '/api/user/getDashboards', method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        deleteContact: builder.mutation({
            query: (id) => ({ url: `/api/contact/delete/${id}`, method: 'DELETE' }),
        }),
        getStaff: builder.query({
            query: (id) => ({ url: `/api/staff/${id}`, method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        saveStaff: builder.mutation({
            query: (model) => ({ url: '/api/staff/save', method: 'POST', body: model }),
        }),
        getDefaultSites: builder.query({
            query: ({ accountId, contactId }) => ({
                url: '/api/site/defaultSites',
                method: 'GET',
                params: stripEmptyParams({ accountId, contactId }),
            }),
            keepUnusedDataFor: 0,
        }),
        getAvailableSites: builder.query({
            query: (accountId) => ({
                url: '/api/site/sitesList',
                method: 'GET',
                params: stripEmptyParams({ accountId }),
            }),
            keepUnusedDataFor: 0,
        }),
        canDeleteUser: builder.query({
            query: (userId) => ({ url: '/api/user/canDelete', method: 'GET', params: { userId } }),
            keepUnusedDataFor: 0,
        }),
        canApplyUserName: builder.query({
            query: ({ userName, userId }) => ({
                url: '/api/user/userNameValid',
                method: 'GET',
                params: stripEmptyParams({ userName, userId }),
            }),
            keepUnusedDataFor: 0,
        }),
        getMyUserProfile: builder.query({
            query: () => ({ url: '/api/user/userProfile', method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        resetPassword: builder.mutation({
            query: (model) => ({ url: '/api/user/resetPassword', method: 'POST', body: model }),
        }),
        sendTemporaryPassword: builder.mutation({
            query: (model) => ({
                url: '/api/user/sendTemporaryPassword',
                method: 'POST',
                body: model,
            }),
        }),
        restoreContact: builder.mutation({
            query: (id) => ({ url: `/api/contact/undelete/${id}`, method: 'POST' }),
        }),
        restoreStaff: builder.mutation({
            query: (id) => ({ url: `/api/staff/undelete/${id}`, method: 'POST' }),
        }),
        deleteStaff: builder.mutation({
            query: (id) => ({ url: `/api/staff/delete/${id}`, method: 'DELETE' }),
        }),
        getUserEmail: builder.query({
            query: () => ({ url: '/api/user/email', method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        getDetailsByUserId: builder.query({
            query: (id) => ({ url: `/api/user/details/${id}`, method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const runUserProfileQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, userProfileApi.endpoints[endpointName], arg);

export const runUserProfileMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, userProfileApi.endpoints[endpointName], arg);

export default userProfileApi;
